import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import store from "./store/configureStore";
import { Provider } from "react-redux";
// Initialize auth synchronization
import "./utils/authSync";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
